import { gql } from '@apollo/client';
const REMOVE_MANUFACTURER_PICTURE = gql `
  mutation RemoveManufacturerPicture($manufacturerId: ID!) {
    removeManufacturerPicture(manufacturerId: $manufacturerId) {
      manufacturer {
        id
        picture
      }
    }
  }
`;
export default REMOVE_MANUFACTURER_PICTURE;
